module.exports = __webpack_public_path__ + "img/comp_round.a56b2f44.png";